import React from 'react';

const PixelButton = ({ children, onClick, className = "", secondary = false }) => {
    const baseClasses = "relative inline-block px-6 py-3 font-vt323 text-xl uppercase tracking-widest transition-transform active:translate-y-1";

    // Pixel art shadow effect using box-shadow
    const primaryShadow = "shadow-[4px_4px_0_0_#000]";
    const secondaryShadow = "shadow-[4px_4px_0_0_#fff]";

    const colors = secondary
        ? "bg-transparent text-white border-4 border-white hover:bg-white hover:text-black"
        : "bg-[#ff0055] text-white border-4 border-[#ff0055] hover:bg-[#ff2266]";

    return (
        <button
            onClick={onClick}
            className={`${baseClasses} ${colors} ${secondary ? secondaryShadow : primaryShadow} ${className}`}
        >
            {children}
        </button>
    );
};

export default PixelButton;
